<template>
  <div id="news-detail">
    <Header></Header>
    <div class="news-detail">
      <h3 class="news-title" v-html="news.title"></h3>
      <div class="news-content" v-html="news.content"></div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
export default {
  name: "NewsDetail",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      news: "null",
      id: null
    };
  },
  mounted() {
    let that = this;
    console.log(this.$route.query.id);
    let id = this.$route.query.id;
    this.$http
      // .post("/api/news/info", {
      .post("http://api.chunhuahealth.com/api/news/info", {
        id: id
      })
      .then(res => {
        that.news = res.data.data;
      });
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/global";
#news-detail {
  width: 100%;
  .news-detail {
    width: $width;
    margin: 0 auto;
    background: #ffffff;
    overflow: hidden;
    .news-title {
      margin-top: 50px;
      text-align: center;
      color: $contentColor;
      font-size: 36px;
      line-height: 50px;
    }
    .news-content {
      margin-top: 20px;
      margin-bottom: 30px;
      color: $publicFontColor;
      text-indent: 2em;
      font-size: 18px;
      line-height: 26px;
      img {
        width: 100%;
      }
    }
  }
}
</style>
